import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el RITMOS LATINOS RESUELTO después de comprar?',
  a: 'Inmediatamente después de confirmar tu pago recibís un email con el acceso a todos los PDFs. En menos de 5 minutos tenés todo disponible para descargar y empezar a usar.'
}, {
  q: '¿Sirve para profes con poca experiencia o solo para los avanzados?',
  a: 'Sirve para todos los niveles. El Tomo 1 está diseñado específicamente para ordenar y profesionalizar a instructores que recién empiezan, y los tomos de ritmos tienen progresiones para principiante, intermedio y avanzado.'
}, {
  q: '¿Es editable? ¿Puedo modificarlo?',
  a: 'No es editable. Es un PDF profesional listo para usar exactamente como está. No necesitás modificar nada porque el contenido ya está pensado para aplicarlo directamente en tu clase.'
}, {
  q: '¿Los 6 bonos están en las dos ofertas?',
  a: 'Sí. Los 6 bonos estratégicos están incluidos en las dos opciones sin costo adicional. La diferencia entre las ofertas es que el Pack Completo incluye además los 2 módulos del Ritmos Pro Avanzado™.'
}, {
  q: '¿Sirve si doy clases individuales o solo para grupos?',
  a: 'Sirve para los dos contextos. El contenido está pensado tanto para clases grupales como para clases individuales, con adaptaciones específicas para cada situación.'
}, {
  q: '¿Sirve si tengo alumnos de distintos niveles al mismo tiempo?',
  a: 'Sí, y es uno de los problemas que mejor resuelve el sistema. El Tomo 5 y el Bono 2 tienen recursos específicos para gestionar grupos heterogéneos con progresiones diferenciadas por nivel.'
}, {
  q: '¿Qué diferencia tiene con otros materiales de ritmos latinos?',
  a: 'Es el único sistema en Argentina diseñado específicamente para instructores, no para bailarines. No es un curso, no es un video, no es una lista de pasos. Es un sistema completo de planificación, progresión y gestión listo para usar desde el primer día.'
}, {
  q: '¿Por qué elegir el Pack Completo y no el estándar?',
  a: 'Si querés resolver solo la planificación y las clases, el estándar es suficiente. Si además querés fidelizar alumnos, aumentar tus precios y diversificar tus ingresos como instructor, el Pack Completo es la opción que más profes eligen.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Si no es lo que esperabas te devolvemos el 100% del dinero sin preguntas y sin formularios.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 md:py-24 bg-neutral-950" data-id="element-102">
      <div className="container mx-auto px-4" data-id="element-103">
        <div className="text-center mb-6 md:mb-16" data-id="element-104">
          <h2 className="text-2xl md:text-5xl font-black text-white" data-id="element-105">
            PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-2 md:space-y-4" data-id="element-106">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`border rounded-lg md:rounded-xl overflow-hidden transition-colors ${isOpen ? 'bg-neutral-900 border-neutral-700' : 'bg-neutral-950 border-neutral-800 hover:border-neutral-700'}`} data-id="element-107">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-4 py-3 md:px-6 md:py-5 flex justify-between items-center text-left focus:outline-none" data-id="element-108">
                  <span className="font-bold text-white text-sm md:text-base pr-3" data-id="element-109">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-neutral-500 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-110" />
                </button>
                <AnimatePresence data-id="element-111">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-112">
                      <div className="px-4 pb-3 text-neutral-400 leading-relaxed" data-id="element-113">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}